import cryptoJs from 'crypto-js' //引用AES源码js

export default {
    // 加密,调用该方法时，传入的data必须是字符串类型，
    // 故，如果要加密对象等类型，需要先用JSON.stringify()将其字符串化再传入
    encryptByAES (data) {
        let dataJSON = JSON.stringify(data);
        var encryptedData = cryptoJs.AES.encrypt(dataJSON, cryptoJs.enc.Base64.parse('XjjkaLnlzAFbR399IP4kdQ=='), {
            mode: cryptoJs.mode.ECB,
            padding: cryptoJs.pad.Pkcs7,
            length: 128
        }).toString();
        var timestamp = new Date().getTime();
        var sign = cryptoJs.SHA1(encryptedData + timestamp + 'QGZUanpSaSy9DEPQFVULJQ==').toString();
        let AESData = {
            sign: sign,
            encryptedData: encryptedData,
            timestamp: timestamp
        };
        return AESData;
    },
    // 解密, 调用该方法时，传入的data是base64的密文
    decryptByAES (data) {
        let keyStr = 'TheKeyOfmyDatadx';
        let key = cryptoJs.enc.Utf8.parse(keyStr);
        let udata = cryptoJs.AES.decrypt(data, key, {
            mode: cryptoJs.mode.ECB,
            padding: cryptoJs.pad.Pkcs7
        });
        let decrypted = udata.toString(cryptoJs.enc.Utf8); // 返回的是加密之前的原始数据,是字符串类型
        return decrypted;
    }
}